import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  HostBinding,
  OnInit,
  OnDestroy,
} from '@angular/core';
import * as screenfull from 'screenfull';
import { DashboardService } from '@shared/services/dashboard.service';
import { SearchFilterEntity } from 'app/interfaces/searchfilter-entity';
import { Subscription } from 'rxjs';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnDestroy {
  @HostBinding('class') public class = 'matero-header';

  @Input() public showBranding = false;

  @Input() public showToggle = true;

  @Output() public toggleSidenav = new EventEmitter<void>();

  @Output() public toggleSidenavNotice = new EventEmitter<void>();

  @Output() public toggleSidebar_: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  public searchEntity_: EventEmitter<SearchFilterEntity> = new EventEmitter<SearchFilterEntity>();

  search_entities!: SearchFilterEntity[];

  sidebarIsOpen = false;

  subscriptions: Subscription[] = [];

  constructor(
    public dashboard_: DashboardService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // LOCAL API Call (via subscription)
    this.subscriptions.push(
      this.dashboard_.api_get_data_search_entities().subscribe(
        data => {
          this.search_entities = data;
          for (const entity in data) {
            // load up GEFMA by default
            if (data[entity].search_entity_label === 'GEFMA') {
              this.openSearchSidebar(data[entity]);
              break;
            }
          }
        },
        error => {
          console.error('Failed to get data from server:', error);
        }
      )
    );
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  private static get screenfull(): screenfull.Screenfull {
    return screenfull as screenfull.Screenfull;
  }

  public toggleFullscreen = () => {
    if (HeaderComponent.screenfull.isEnabled) {
      HeaderComponent.screenfull.toggle();
    }
  };

  public openDashboardParameterless() {
    sessionStorage.removeItem('location');
    sessionStorage.removeItem('contractNumber');
    sessionStorage.removeItem('documentType');
    sessionStorage.removeItem('createdAt');
    this.router.navigate(['dashboard/']);
  }

  public openDashboard(filterId: number) {
    let nextRoute = 'dashboard/' + filterId;

    if (this.hasAnyInputInSearchFilter()) {
      nextRoute = nextRoute + '/filter';
    }

    const navigationExtras = {
      queryParams: this.route.snapshot.queryParams,
      queryParamsHandling: 'merge',
    } as NavigationExtras;

    this.router.navigate([nextRoute], navigationExtras);
  }

  toggleSidebar = () => {
    this.sidebarIsOpen = !this.sidebarIsOpen;
    this.toggleSidebar_.emit(this.sidebarIsOpen);
  };

  openSearchSidebar = (entity: SearchFilterEntity) => {
    this.searchEntity_.emit(entity);
  };

  private hasAnyInputInSearchFilter(): boolean {
    const hasLocation = sessionStorage.getItem('location') !== null;
    const hasContractNumber = sessionStorage.getItem('contractNumber') !== null;
    const hasDocumentType = sessionStorage.getItem('documentType') !== null;
    const hasDate = sessionStorage.getItem('createdAt') !== null;
    return hasLocation || hasContractNumber || hasDocumentType || hasDate;
  }
}
